import { Box, BoxProps } from '@amzn/awsui-components-react';
import React from 'react';

import { formatCurrencyNoDecimals, formatNumber, formatPercentage, formatPercentageAsString } from '../../../common/LocalizationHelper';
import { roundToInteger } from '../../../common/util';
import { SummaryRowFormat, SummaryRowNumberDisplayOptions } from './MainframeTypes';

export const formatCell = (value: string | number, format: SummaryRowFormat | undefined, currency: string | undefined) => {
    let variant: BoxProps.Variant | undefined = undefined;
    let textAlign: BoxProps.TextAlign | undefined = undefined;
    let formattedValue: string | JSX.Element;

    if (typeof (value) === 'number') {
        if (format?.numberDisplay === SummaryRowNumberDisplayOptions.PERCENTAGE) {
            formattedValue = formatPercentage(value);
        } else if (currency) {
            formattedValue = formatCurrencyNoDecimals(value, currency);
        } else {
            formattedValue = formatNumber(value);
        }
    } else {
        formattedValue = value;
    }

    if (format?.textStyle) {
        variant = format.textStyle;
    }

    if (format?.align) {
        textAlign = format.align;
    }

    return (
        <Box textAlign={textAlign} variant={variant}>{formattedValue}</Box>
    );
};

/**
 * Correctly format the given value based on the format options
 * percentages are converted to % notation
 * currency values are displayed with zero decimal places
 * @param value 
 * @param format 
 * @param currency 
 * @returns 
 */
export const formatData = (value: string | number, format: SummaryRowFormat | undefined, currency: string | undefined): string | number => {
    if (typeof (value) === 'number') {
        if (format?.numberDisplay === SummaryRowNumberDisplayOptions.PERCENTAGE) {
            return formatPercentageAsString(value);
        } else if (currency) {
            return roundToInteger(value);
        }
    }
    return value;
};
